<template lang="pug">
f7-page#unsent-curriculums
  navbar(title="カリキュラムを送信" back)

  background
    unsent-curriculums-query(:studentId="studentId" fetchPolicy="network-only")
      template(slot-scope="{ unsentCurriculums, student }")
        curriculum-receiver(:student="student")
        unsent-curriculum-list(
          v-if="unsentCurriculums"
          :curriculums="unsentCurriculums"
          @click="showDetail"
          @send="onClickSend")
</template>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import UnsentCurriculumsQuery from '@/components/queries/UnsentCurriculumsQuery'
import UnsentCurriculumList from '@/components/organisms/UnsentCurriculumList'
import CurriculumReceiver from '@/components/molecules/CurriculumReceiver'
import { SEND_CURRICULUM } from '@/graphql'

export default {
  mixins: [PageTitle],
  title: 'カリキュラムを送信',
  components: {
    UnsentCurriculumsQuery,
    UnsentCurriculumList,
    CurriculumReceiver,
  },
  data() {
    return {
      studentId: null,
    }
  },
  methods: {
    showDetail(curriculumId) {
      this.$f7router.navigate(`/curriculums/${curriculumId}/show`)
    },
    onClickSend(curriculumId) {
      this.$f7.dialog.confirm('カリキュラムを送信します', '確認', () => {
        this.sendCurriculum({
          curriculumId: curriculumId,
          studentId: this.$f7route.params.studentId,
        })
      })
    },
    async sendCurriculum(variables) {
      this.$f7.dialog.preloader('送信中...')
      await this.$apollo
        .mutate(SEND_CURRICULUM(variables))
        .catch(this.handleGQLError)
      this.$f7.dialog.close()
      this.$f7router.back()
    },
  },
  created() {
    this.studentId = this.$f7route.params.studentId
  },
}
</script>
